﻿import _ from 'lodash';
import axios from 'axios';
import {DataToolsConfig as DataTools} from '../constants/ApplicationConstants.js';
import AddressApiCallBackActions from '../actions/AddressApiCallBackActions.js';
import {getError as Error, ThrowIfStatusNotOk} from './ApiHelper.js';

﻿let cache = [{ searchString: '', options: [] }];

function createAddress(data) {
    return data.address_line + ', ' + data.locality + ', ' + data.state + ', ' + data.postcode
}

function addressExists(options, val) {
    if (options && options.length > 0) {
        const address = _.find(options, function (o) {
            var opt = (typeof o === 'object') ? createAddress(o) : o;
            return val.toLowerCase() === opt.toLowerCase()
        });
        return Boolean(address);
    }
    return false;
}

function appendUrlKeys(url, domainKeys) {
    var newUrl = url;
    var splitKeys = domainKeys.split('|');

    //datatools need exactly five urlkeys in the request, so we need to send them five even if we have to pass empty ones
    var diff = 5 - splitKeys.length;
    for (var j = 0; j < diff; j++) {
        splitKeys.push('');
    }
    for (var i = 0; i < splitKeys.length; i++) {
        newUrl = newUrl + '&UrlKey' + (i + 1) + '=' + splitKeys[i];
    }
    return newUrl;
}

function getServiceUrl(searchString) {
    //attach the search string to url
    var url = window.NOA.configuration.dataToolsStartUrl + DataTools.SEARCH_URL_START + searchString + DataTools.SEARCH_URL_END;
    //append url keys
    url = appendUrlKeys(url, window.NOA.configuration.dataToolsUrlKey);
    return url;
}

function removeAddressSeparation(address){
    if (!address){
        return '';
    }
    return address.replace(/,/g, '');
}

﻿module.exports = {
﻿    fetchOptions: function(id, value, type) {
﻿        //https://cbarbsdandt.datatoolscloud.net.au/dt_webservice/dt.asmx/DtSearchAddressLinePredictive_jsonp?callback=&ResultLimit=5&AddressLine=1+quarry&DisplayOnlyCountryCode=AU&UrlKey1=D0050-09121-47432-40093&UrlKey2=&UrlKey3=&UrlKey4=&UrlKey5=
﻿        if (value) {
﻿            let result = _.find(cache, { searchString: value }), url = getServiceUrl(value), address = [];

﻿            if (result) {
﻿                AddressApiCallBackActions.receivedOptions(id, result.options, type);
﻿            } else {
                 const handleError = (error) => {
                     console.error(Error('Address', error));
                     AddressApiCallBackActions.receivedOptions(id, [], type);
                 };

﻿                axios.get(url, { timeout: window.NOA.configuration.dataToolsTimeout })
﻿                    .then(ThrowIfStatusNotOk)
﻿                    .then((response) => {
﻿                        _.each(response.data.items,
﻿                            function(n) {
﻿                                address.push(createAddress(n));
﻿                            });
﻿                        result = address;
﻿                        cache.push({ searchString: value, options: result })
﻿                        AddressApiCallBackActions.receivedOptions(id, result, type);
﻿                    })
﻿                    .catch((error) => handleError(error));
﻿            }
﻿        } else {
﻿            handleError(response);
﻿        }
﻿    },
﻿    validateAddressAndPostal: function(id, val, validationType, model, index, addressType) {
﻿        const searchString = val.split(',');
         const handleError = (error) => {
             console.error(Error('Address validating', error));
             AddressApiCallBackActions
                 .receivedValidationResult(id, false, validationType, model, val, index, addressType);
         };

﻿        let removedDelAddress = removeAddressSeparation(val).toLowerCase();
﻿        let cachedAddress = _.find(cache,
﻿            function(o) {
﻿                if (_.startsWith(removedDelAddress, removeAddressSeparation(o.searchString).toLowerCase())) {
﻿                    return addressExists(o.options, val);
﻿                }
﻿            });

﻿        if (cachedAddress) {
﻿            AddressApiCallBackActions
﻿                .receivedValidationResult(id, true, validationType, model, val, index, addressType);
﻿        } else {
﻿            axios.get(getServiceUrl(encodeURIComponent(searchString[0])),
﻿                {
﻿                    timeout: window.NOA.configuration.dataToolsTimeout
﻿                })
﻿                .then(ThrowIfStatusNotOk)
﻿                .then((response) => {
﻿                    const result = addressExists(response.data.items, val);

﻿                    AddressApiCallBackActions
﻿                        .receivedValidationResult(id, result, validationType, model, val, index, addressType);
﻿                })
﻿                .catch((error) => handleError(error));
﻿        }
﻿    }
﻿};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./apis/AddressAPI.js